import React from 'react';
import WalletBalance from '../../../wallet/WalletBalance';

const PageBarBalance = () => <WalletBalance />;
export default PageBarBalance;
